export const SEGMENT_CATEGORY = {
  ENTREPRISE: 'entreprise',
  ECO: 'eco',
  RELAY: 'relay',
} as const;

export type SegmentCategory = typeof SEGMENT_CATEGORY[keyof typeof SEGMENT_CATEGORY];
